import{a as o}from"./chunk-6UXBIUZJ.mjs";var t=class{constructor(n){this.config=n}async transferCoinTransaction(n){return o({aptosConfig:this.config,...n})}};export{t as a};
//# sourceMappingURL=chunk-LD47JFHP.mjs.map